// extracted by mini-css-extract-plugin
export default {"p_tye":"f425e411d2","slcted":"_13401d23cf","slc_color":"a11e840c26","item_p":"_71fc8424c0","r0":"_0c39889a27"};